module.exports = __webpack_public_path__ + "img/play-btn.53c4ef4b.png";